module.exports = __webpack_public_path__ + "static/img/Gacha19.ccdd961.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/gasha/Gacha19.png
// module id = aCst
// module chunks = 1